import angular from 'angular';

angular.module('webTools').filter('startsWith', function () {
    return function (array, search) {
        console.log(search)
            var f = [];
            for (var i = 0; i < array.length; i++) {
                if (array[i].toLowerCase().indexOf(search.toLowerCase()) === 0 &&
                    search.length < array[i].length) {
                    f.push(array[i]);
                }
            }
            return f;
        };
    });